<div class="favorites-container">
  <button mat-raised-button color="primary" *ngIf="saveAvailable" (click)="saveOrder()">
    <mat-icon>save</mat-icon>
    Save Changes
  </button>

  <div cdkDropList class="favorites-list" (cdkDropListDropped)="drop($event)">
    <div class="favorite-item" *ngFor="let fave of favorites" cdkDrag>
      <span class="drag-handle" cdkDragHandle>
        <mat-icon>drag_indicator</mat-icon>
      </span>
      <a [routerLink]="fave.path" class="favorite-link">
        <mat-icon>{{ fave.icon }}</mat-icon>
        {{ fave.title }}
      </a>
      <button mat-icon-button color="warn" (click)="removeFavorite(fave.faveid)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <p class="no-results" *ngIf="!favorites.length">No Favorites Added</p>
</div>
